// Shared ChartzFx logo. The transparent logo image already contains the wordmark,
// so we never render additional text next to it. Pass `size` (desktop px) and
// optional `mobileSize` (px) for a smaller mobile render.
export const Logo = ({ size = 50, mobileSize, className = "" }) => {
  const cls = `shrink-0 select-none ${className}`;
  if (typeof mobileSize === "number" && mobileSize !== size) {
    return (
      <>
        <img
          src="/logo.png"
          alt="ChartzFx"
          draggable={false}
          style={{ height: mobileSize, width: "auto" }}
          className={`${cls} sm:hidden`}
        />
        <img
          src="/logo.png"
          alt="ChartzFx"
          draggable={false}
          style={{ height: size, width: "auto" }}
          className={`${cls} hidden sm:block`}
        />
      </>
    );
  }
  return (
    <img
      src="/logo.png"
      alt="ChartzFx"
      draggable={false}
      style={{ height: size, width: "auto" }}
      className={cls}
    />
  );
};
